import { getCopTokenAuthConfig } from '../components/SilentTokenProvider/config';
export const COP_API_BASE_URL = getCopTokenAuthConfig().apiBaseUrl.replace(/\/$/, '')
export const CURRENT_USER_ENDPOINT = '/api/users/current'
export const getPermissionsUrl = (customerId: string): string =>
  `${COP_API_BASE_URL}/api/Customers/${encodeURIComponent(customerId)}/PermissionsV2`
export const CASE_DETAILS_ENDPOINT = '/api/v2/odata/cases/GetCaseDetails'
export const AGREEMENTS_ENDPOINT = '/api/v2/odata/EncompassAgreements/GetDetails'
export const AGREEMENTS_LIST_BY_SITE_ENDPOINT = '/api/v2/odata/EncompassAgreements/GetListBySiteId'
export const ASSET_DETAILS_ENDPOINT = '/api/v2/odata/assets/GetIEDAssetDetails'
export const USER_NOTIFICATION_SETTINGS_ENDPOINT = '/api/UserNotificationSettings'
export const CASE_COMMENTS_DETAILS_ENDPOINT = '/api/v2/odata/cases/GetCaseCommentsAndFiles'
export const CASE_HISTORY_DETAILS_ENDPOINT = '/api/v2/odata/cases/GetCaseHistoryEvents'
export const ADD_COMMENT_ENDPOINT = '/api/Cases/AddComment'
export const APPROVE_CASE_ENDPOINT = '/api/Cases/ApproveCase'
export const REJECT_CASE_ENDPOINT = '/api/Cases/RejectCase'
export const ADD_CASE_ENDPOINT = '/api/Cases/AddCase'
export const PERFORMANCE_OVERVIEW_ENDPOINT = '/api/home/performanceOverview'
export const AGREEMENT_EXPORT_LIST_ENDPOINT = '/api/v2/odata/sites/ExportListForEncompassAgreement'
export const SITES_EXPORT_LIST_ENDPOINT = '/api/v2/odata/sites/ExportList'
export const ASSETS_BASE_ENDPOINT = '/api/v2/odata/assets'
export const REPORT_ASSET_DATA_ISSUE_ENDPOINT = '/api/v2/odata/assets/ReportDataIssue'
export const REPORT_SITE_DATA_ISSUE_ENDPOINT = '/api/v2/odata/sites/ReportDataIssue'
export const ASSETS_SEARCH_ENDPOINT = '/api/v2/odata/assets/SearchAssets()'
export const ASSETS_CUSTOMER_BUSINESS_LIST_ENDPOINT = '/api/v2/odata/assets/GetCustomerBusinessUnits()'
export const ASSETS_PRODUCT_CATEGORIES_ENDPOINT = '/api/v2/odata/assets/GetProductCategoriesForBusinessUnit'
export const CUSTOMERS_ENDPOINT = '/api/v2/odata/customers'
export const CUSTOMERS_COUNT_ENDPOINT = '/api/v2/odata/Customers/$count'
export const AGREEMENTS_LIST_ENDPOINT = '/api/v2/odata/EncompassAgreements/GetList()'
export const SUBSCRIPTIONS_LIST_ENDPOINT = '/api/v2/odata/Subscriptions/GetList()'
export const CASES_ENDPOINT = '/api/v2/odata/cases'
export const SITE_DETAILS_ENDPOINT = '/api/v2/odata/sites'
export const SITE_TREE_VIEW_ENDPOINT = '/api/v2/odata/Sites/GetTreeView'
export const SITE_EXPORT_DETAILS_ENDPOINT = '/api/v2/odata/sites/ExportDetails'
export const COUNTRIES_ENDPOINT = '/api/location/countries'
export const CUSTOMER_USERS_LIST_ENDPOINT = '/api/v2/odata/customerUsers/GetList'
export const SUBSCRIPTION_SITES_LIST_ENDPOINT = '/api/v2/odata/sites/GetListForCustomer'
export const SUBSCRIPTIONS_ENDPOINT = '/api/subscriptions'
export const USERS_ENDPOINT = '/api/users'
export const ROLES_ENDPOINT = '/api/roles'
export const PRODUCT_CATEGORIES_ENDPOINT = '/api/v2/odata/assets/GetProductCategories()'
export const SEND_NOTIFICATION_ENDPOINT = '/api/sendnotification'
export const APP_NOTIFICATION_URL = '/api/v2/odata/AppNotifications'
export const getNotificationCategoriesUrl = (): string =>
  `${COP_API_BASE_URL}${APP_NOTIFICATION_URL}/GetCategories()`
export const PATCH_MANAGEMENT_URL = '/api/v2/odata/PatchManagement'
export const getPatchManagementCategoriesUrl = (): string =>
  `${COP_API_BASE_URL}${PATCH_MANAGEMENT_URL}/GetCategories()`
export const getPatchManagementDownloadUrl = (fileId: string): string => {
  if (typeof fileId !== 'string' || fileId.trim() === '') {
    throw new Error('Missing fileId for PatchManagement download')
  }
  return `${COP_API_BASE_URL}${PATCH_MANAGEMENT_URL}/Download(fileId='${escapeODataString(fileId)}')`
}
export const SIGNALR_NEGOTIATE_URL = '/hubs/notifications/negotiate'
export const TOKEN_EXCHANGE_URL = '/api/tokenExchange/exchange'

export const HTML_ORDER_ALLOWED_PRODUCT_FAMILIES_ENDPOINT = '/api/htmlOrder/allowedProductFamiliesInOrder'
export const getAllowedProductFamiliesInOrderUrl = (): string =>
  `${COP_API_BASE_URL}${HTML_ORDER_ALLOWED_PRODUCT_FAMILIES_ENDPOINT}`

export const RMA_REQUEST_ENDPOINT = '/api/rmaRequest'
export const getRmaRequestFileUrl = (fileName: string): string => {
  if (typeof fileName !== 'string' || fileName.trim() === '') {
    throw new Error('Missing fileName for RMA request file URL')
  }
  return `${COP_API_BASE_URL}${RMA_REQUEST_ENDPOINT}/${encodeURIComponent(fileName.trim())}`
}

export const HTML_DOCUMENTATION_ENDPOINT = '/api/htmlDocumentation/docs'
export const getHtmlDocumentationUrl = (id: string): string => {
  if (typeof id !== 'string' || id.trim() === '') {
    throw new Error('Missing id for HTML documentation URL')
  }
  return `${COP_API_BASE_URL}${HTML_DOCUMENTATION_ENDPOINT}/${encodeURIComponent(id.trim())}`
}

export const HTML_DOCUMENTATION_BASE_ENDPOINT = '/api/htmlDocumentation'
export const getHtmlDocumentationByFamilyUrl = (productFamily: string): string => {
  if (typeof productFamily !== 'string' || productFamily.trim() === '') {
    throw new Error('Missing productFamily for HTML documentation list URL')
  }
  return `${COP_API_BASE_URL}${HTML_DOCUMENTATION_BASE_ENDPOINT}/${encodeURIComponent(productFamily.trim())}`
}

export const HTML_DOCUMENTATION_DOWNLOAD_ENDPOINT = '/api/htmlDocumentation/download'
export const getHtmlDocumentationResourceUrl = (relativeFilePath: string): string => {
  if (typeof relativeFilePath !== 'string' || relativeFilePath.trim() === '') {
    throw new Error('Missing relativeFilePath for HTML documentation resource URL')
  }
  // Keep the path structure but encode each segment (e.g. spaces) safely.
  const encodedPath = relativeFilePath
    .trim()
    .replace(/^\/+/, '')
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/')
  return `${COP_API_BASE_URL}${HTML_DOCUMENTATION_DOWNLOAD_ENDPOINT}/${encodedPath}`
}

export const getHtmlDocumentationCookiePath = (relativeFilePath: string): string => {
  if (typeof relativeFilePath !== 'string' || relativeFilePath.trim() === '') {
    throw new Error('Missing relativeFilePath for HTML documentation cookie path')
  }
  const firstSegment = relativeFilePath.trim().replace(/^\/+/, '').split('/')[0]
  return `${HTML_DOCUMENTATION_DOWNLOAD_ENDPOINT}/${encodeURIComponent(firstSegment)}`
}
export type AgreementExportType = 'Excel' | 'PDF'

const escapeODataString = (value: string): string => value.replace(/'/g, "''")
const buildODataKeyUrl = (path: string, paramName: string, value: string): string => {
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`Missing value for OData parameter "${paramName}"`)
  }
  return `${path}(${paramName}='${escapeODataString(value)}')`
}
const buildQueryUrl = (path: string, params: Record<string, string | number | boolean | undefined | null>): string => {
  const search = new URLSearchParams()
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, String(value))
    }
  })
  const qs = search.toString()
  return qs ? `${path}?${qs}` : path
}

export const getCaseDetailsUrl = (caseId: string): string => buildODataKeyUrl(CASE_DETAILS_ENDPOINT, 'caseId', caseId)
export const getAgreementDetailsUrl = (encompassAgreementId: string): string =>
  buildODataKeyUrl(AGREEMENTS_ENDPOINT, 'encompassAgreementId', encompassAgreementId)
export const getAgreementExportListUrl = (encompassAgreementId: string, exportType: AgreementExportType): string => {
  if (typeof exportType !== 'string' || exportType.trim() === '') {
    throw new Error('Missing exportType for agreement export')
  }

  const escapedAgreementId = escapeODataString(encompassAgreementId)
  const escapedExportType = escapeODataString(exportType)

  return `${AGREEMENT_EXPORT_LIST_ENDPOINT}(encompassAgreementId='${escapedAgreementId}',exportType='${escapedExportType}')`
}

export const getAssetDetailsUrl = (assetId: string): string => buildODataKeyUrl(ASSET_DETAILS_ENDPOINT, 'assetId', assetId)

export const getSiteDetailsUrl = (siteId: string): string => {
  if (!siteId?.trim()) {
    throw new Error('Missing siteId for site details URL')
  }
  return `${SITE_DETAILS_ENDPOINT}/${encodeURIComponent(siteId)}`
}

export const UPDATE_SITE_CONTACTS_ENDPOINT = '/api/v2/odata/sites/UpdateContacts'

export const getSiteExportDetailsUrl = (siteId: string, exportType: AgreementExportType): string => {
  if (typeof exportType !== 'string' || exportType.trim() === '') {
    throw new Error('Missing exportType for site export')
  }
  const escapedId = escapeODataString(siteId)
  const escapedType = escapeODataString(exportType)
  return `${SITE_EXPORT_DETAILS_ENDPOINT}(siteId='${escapedId}',exportType='${escapedType}')`
}

export const getUserNotificationSettingsUrl = (customerId: string | number): string => {
  if (customerId === undefined || customerId === null || String(customerId).trim() === '') {
    throw new Error('Missing customerId for UserNotificationSettings')
  }
  return buildQueryUrl(USER_NOTIFICATION_SETTINGS_ENDPOINT, { customerId })
}

export const getCaseFileUrl = (caseId: string, fileName: string): string => {
  if (!caseId?.trim() || !fileName?.trim()) {
    throw new Error('Missing caseId or fileName for case file URL')
  }
  return `/api/cases/${encodeURIComponent(caseId)}/files/${encodeURIComponent(fileName)}`
}

export const getCaseCommentsUrl = (caseId: string): string => buildODataKeyUrl(CASE_COMMENTS_DETAILS_ENDPOINT, 'caseId', caseId)
export const getCaseHistoryUrl = (caseId: string): string => buildODataKeyUrl(CASE_HISTORY_DETAILS_ENDPOINT, 'caseId', caseId)
export const getPerformanceOverviewUrl = (): string => PERFORMANCE_OVERVIEW_ENDPOINT
export const assetSearchUrl = (): string => ASSETS_SEARCH_ENDPOINT
export const getCustomerBusinessUnitsUrl = (): string => ASSETS_CUSTOMER_BUSINESS_LIST_ENDPOINT
export const getProductCategoriesUrl = (businessUnitId: number): string => {
  if (!Number.isInteger(businessUnitId) || businessUnitId <= 0) {
    throw new Error('Invalid businessUnitId for GetProductCategoriesForBusinessUnit')
  }
  return `${ASSETS_PRODUCT_CATEGORIES_ENDPOINT}(businessUnitId=${businessUnitId})`
}

export const getAgreementListBySiteUrl = (siteId: string, params?: Record<string, string | number | boolean | undefined>): string => {
  if (!siteId?.trim()) {
    throw new Error('Missing siteId for GetListBySiteId')
  }

  const escapedSiteId = escapeODataString(siteId)
  const baseUrl = `${AGREEMENTS_LIST_BY_SITE_ENDPOINT}(siteId='${escapedSiteId}')`

  if (!params || Object.keys(params).length === 0) {
    return baseUrl
  }

  return buildQueryUrl(baseUrl, {
    $orderby: params.orderby,
    $count: params.count,
    $top: params.top,
    $skip: params.skip,
    $filter: params.filter,
  })
}
export const getCustomerUsersUrl = (customerId: string): string =>
  buildODataKeyUrl(CUSTOMER_USERS_LIST_ENDPOINT, 'customerId', customerId)

export const getSubscriptionSitesUrl = (customerId: string): string =>
  `${buildODataKeyUrl(SUBSCRIPTION_SITES_LIST_ENDPOINT, 'customerId', customerId)}?$select=id`

export const getSubscriptionByIdUrl = (id: string): string => {
  const params = new URLSearchParams({
    '$orderby': 'customerName asc',
    '$count': 'true',
    '$top': '10',
    '$skip': '0',
    '$filter': `id eq ${id}`,
  })
  return `${SUBSCRIPTIONS_LIST_ENDPOINT}?${params.toString()}`
}